import React, { useEffect } from 'react';

import { DocumentPermissionsDialog } from './Permissions/DocumentPermissionsDialog';
import { useDocumentPermissions } from '@/hooks/business/useDocumentPermissions';

interface DocumentPermissionsProps {
  open: boolean;
  onClose: () => void;
  documentId: string;
  documentTitle: string;
  onPermissionsUpdated?: () => void;
}

const DocumentPermissions: React.FC<DocumentPermissionsProps> = ({
  open,
  onClose,
  documentId,
  documentTitle,
  onPermissionsUpdated
}) => {
  const {
    editMode,
    setEditMode,
    permissions,
    accessInfo,
    isLoadingAccess,
    accessError,
    isUpdatingPermissions,
    updateError,
    loadAccessInfo,
    handleUpdatePermissions,
    handleFieldChange
  } = useDocumentPermissions(documentId, onPermissionsUpdated);

  useEffect(() => {
    if (open && documentId) {
      void loadAccessInfo(); // Explicitly mark as intentionally not awaited
    }
  }, [open, documentId, loadAccessInfo]);

  return (
    <DocumentPermissionsDialog
      open={open}
      onClose={onClose}
      documentTitle={documentTitle}
      editMode={editMode}
      setEditMode={setEditMode}
      permissions={permissions}
      accessInfo={accessInfo}
      isLoadingAccess={isLoadingAccess}
      accessError={accessError}
      isUpdatingPermissions={isUpdatingPermissions}
      updateError={updateError}
      handleUpdatePermissions={handleUpdatePermissions}
      handleFieldChange={handleFieldChange}
    />
  );
};

export default DocumentPermissions;